import React from "react";
import Navbar from "../../components/Navbar/Navbar";
import Trail from "../../components/Trail/Trail";
import Footer from "../../components/Footer/Footer";
import ContactSalesForm from "../../components/contact-sales-form/ContactSalesForm";

export default function ContactSales() {
  return (
    <>
      <Navbar />
      <ContactSalesForm />
      <Trail />
      <Footer />
    </>
  );
}
